import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css"; // All styles consolidated in index.css

createRoot(document.getElementById("root")!).render(<App />);
